<template>
	<el-submenu v-if="menu.columnMenuList && menu.columnMenuList.length >= 1" :index="'' + menu.id.toString()"
		@click="goTag(menu),handleSelect(menu)">
		<template slot="title">
			<i class="iconfont" :class="[menu.icont != ''?menu.icont:'']"></i>
			<span>{{menu.columname}}</span>
		</template>
		<NavMenu v-for="item in menu.columnMenuList" :key="item.id" :menu="item" @handleSelect="handleSelect(menu)">
		</NavMenu>
	</el-submenu>
	<el-menu-item v-else :index="menu.id.toString()" @click="goTag(menu),handleSelect(menu)">
		<!-- {{menu.columname} -->
			<i class="iconfont" :class="[menu.icont != ''?menu.icont:'']"></i>
			<span slot="title">{{menu.columname}}</span>
	</el-menu-item>
</template>

<script>
	export default {
		name: 'NavMenu',
		props: ['menu'],
		data() {
			return {}
		},
		created() {

		},
		methods: {
			goTag(item) {
				// this.$emit('handleSelect', item)
				this.$router.push({
					path: item.routeName,
					query: {
						id: item.id
					}
				})
			},
			handleSelect(item) {
				var items = item
				this.$store.commit('selectMenu', items)
			},
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-submenu__title i{
		font-size: 18px;
		color: #FFFFFF;
	}
	/deep/ .el-menu-item{
		background-color: #131726!important;
	}
	/deep/ .el-menu-item:hover{
		background-color: #090B12!important;
	}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue